import React, { Component } from "react";

class Button extends Component {

  closeChat = () => {
    this.props.onCloseChat()
  }

  render() {
    return(
      <button title='Fermer' className='btn close' onClick={this.closeChat}></button>
    )
  }
}

export default Button
